module.exports = __webpack_public_path__ + "application/templates/default/inner/movements/inss/manager/inss-manager.template.html";